$('.fr_title').click(function(){
    var Toheight = $(this).next('.fr_text')[0].scrollHeight
    var heightFlag = $(this).next('.fr_text').css('height')
    if(heightFlag == '0px'){
        $(this).children('.fri_right').children('.fri_line').addClass('fri_active')
        $(this).next('.fr_text').css({height:`${Toheight}px`})
    }else{
        $(this).children('.fri_right').children('.fri_line').removeClass('fri_active')
        $(this).next('.fr_text').css({height:'0',margin:'0'})
    }
})

$('.fcl_item').click(function(){
    var index = $(this).index()+1
    $('.fr_items').hide()
    $(`.fc_right .fr_items:nth-child(${index})`).show()
    $('.fcl_item').css({background:'rgba(0,0,0,0)'})
    $(this).css({background:'red'})
})

$(function(){
    // 遍历所有 .fr_text span 元素
    $('.fr_text span').each(function(index) {
        // 创建新的样式元素
        const style = document.createElement('style');
        // 创建样式规则并设置内容
        style.innerHTML = `.fr_text span:nth-child(${index + 1})::before { content: '${index + 1}.'; }`;
        // 将样式规则插入到文档中的样式表中
        document.head.appendChild(style);
    });
})

var frtFlag = true
$('.frt_border').click(function(){
    if(frtFlag){
        $(this).addClass('frt_border_active')
        frtFlag = false
    }else{
        $(this).removeClass('frt_border_active')
        frtFlag = true
    }
})


var supportUs = new Vue({
    el:'#supportUs',
    data:function(){
        return{
            info1:{
                name:'',
                email:'',
                phone:'',
                method:'',
                date:'',
                message:''
            },
            submitFlag:true,
        }
    },
    methods:{
        async submit1(event){
            if(!this.submitFlag){
                //不能重复提交 
                event.preventDefault();  
                return;
            }
            if(this.info1.name==''||this.info1.email==''||this.info1.phone==''||this.info1.method==''||this.info1.date==''||this.info1.message==''){
                showMessage('Please fill in the information completely','error')
            }else{
                // 邮箱正则表达式
                var emailReg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
                if(emailReg.test(this.info1.email)){
                    showMessage('Sent successfully','success')
                    this.submitFlag = false
  
                    var params=new URLSearchParams();
                    params.append('info',JSON.stringify(this.info1));
                    let result=await axios.post('https://service.oxvatech.cn/email/vagendSupport',params);
                    if(result.status == 200){
                        window.location.reload()
                    }
                }else{
                    showMessage('Email format error','error')
                }
            }
        }
    }
  })